import DepositTo from '#client/components/CheckDeposit/components/DepositTo';

import SummaryDetails from './SummaryDetails';
import { DividerStyled, SectionWrapperStyled } from '../CheckDepositSubmissionOverview.styles';

const Summary = () => (
  <SectionWrapperStyled>
    <DepositTo title="Deposited to" />
    <DividerStyled />
    <SummaryDetails
      title="Available in"
      value="5-7 business days"
    />
  </SectionWrapperStyled>
);

export default Summary;
